import * as React from 'react';
import type { FieldValues } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import type { MarketplaceLead } from '@gcv/shared';
import { MarketplaceLeadStatus } from '@gcv/shared';
import { Box } from '@mui/material';

import { useComponent } from 'hooks';
import { useUpdateBankMarketplaceLead } from 'hooks/mutations';
import { getSnackbarStore } from 'stores/SnackBarStore';
import { Button, Dialog, InputSelect, InputText } from 'ui';

export const ArchiveLeadModal: React.FC<{
  lead: MarketplaceLead;
  isOpen: boolean;
  onClose: (newStatus?: MarketplaceLeadStatus) => void;
  status?: MarketplaceLeadStatus;
}> = useComponent((props) => {
  const { lead, status, isOpen, onClose } = props;

  const { updateBankMarketplaceLead, isPutBankMarketplaceLeadPending } = useUpdateBankMarketplaceLead();

  const form = useForm({
    mode: 'onBlur',
    defaultValues: {
      status: status,
      internalComment: lead?.fi_internal_comment
    } as FieldValues
  });

  const updateLead = async (props: {
    status: MarketplaceLeadStatus;
    internalComment?: string;
    externalComment?: string;
  }) => {
    try {
      await updateBankMarketplaceLead({
        id: lead.id,
        ...props
      });
    } catch {
      getSnackbarStore().showErrorSnackbarMessage(
        'There was an issue updating the lead. Contact support for additional help.'
      );
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      title="Archive Lead"
      handleClose={() => onClose()}
      action={
        <Button
          style={{ width: '105px' }}
          label="Archive"
          color="primary"
          variant="text"
          onClick={form.handleSubmit(async (data) => {
            await updateLead({ status: data.status, internalComment: data.internalComment });
            onClose(data.status);
          })}
          isLoading={isPutBankMarketplaceLeadPending}
        />
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <InputSelect
          label={'Lead Status'}
          name={'status'}
          rules={{ required: { message: 'is required', value: true } }}
          options={Object.values(MarketplaceLeadStatus)
            .filter((s) => s === MarketplaceLeadStatus.Not_A_Fit || s === MarketplaceLeadStatus.Unqualified)
            .map((s) => {
              return { value: s, label: s };
            })}
          {...form}
        />
        <InputText
          label={'Internal Comment'}
          name={'internalComment'}
          rules={{ required: { message: 'is required', value: true } }}
          {...form}
        />
        {/* <InputText label={'External Comment'} name={'externalComment'} {...form} /> */}
      </Box>
    </Dialog>
  );
});
